import React, {useState} from 'react';
import {Alert, Button, Modal, Space, Typography, Tabs} from 'antd';
import {ReloadOutlined, SafetyCertificateOutlined, SettingOutlined, LaptopOutlined} from '@ant-design/icons';
import {refreshMyApiCache} from '../api/meApi';
import {message} from 'antd';
import ActiveSessionsManager from './ActiveSessionsManager';

const { Paragraph, Text } = Typography;

function UserSettingsModal({ open, isOpen, onCancel, onClose, onRefreshed, user }) {
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('cache');

  const openFinal = typeof open !== 'undefined' ? open : !!isOpen;
  const onCancelFinal = onCancel || onClose || (() => {});

  const handleRefresh = async () => {
    setLoading(true);
    try {
      await refreshMyApiCache();
      message.success('사용자 API 패턴 캐시를 갱신했습니다.');
      if (onRefreshed) {
        onRefreshed();
      } else {
        onCancelFinal();
      }
    } catch (error) {
      const fallback = '캐시 갱신에 실패했습니다. 잠시 후 다시 시도해주세요.';
      const apiMessage = error?.response?.data?.message || error?.message || fallback;
      message.error(apiMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={(
        <Space>
          <SettingOutlined />
          <span>사용자 설정</span>
        </Space>
      )}
      open={openFinal}
      onCancel={onCancelFinal}
      footer={
        activeTab === 'cache' ? [
          <Button key="close" onClick={onCancelFinal} disabled={loading}>닫기</Button>,
          <Button key="refresh" type="primary" icon={<ReloadOutlined />} loading={loading} onClick={handleRefresh}>
            API 캐시 갱신
          </Button>
        ] : [
          <Button key="close" onClick={onCancelFinal}>닫기</Button>
        ]
      }
      width={720}
    >
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={[
          {
            key: 'cache',
            label: (
              <Space>
                <SafetyCertificateOutlined />
                <span>API 권한</span>
              </Space>
            ),
            children: (
              <Space direction="vertical" size="large" style={{ width: '100%' }}>
                <Alert
                  type="info"
                  message={(
                    <Space>
                      <SafetyCertificateOutlined style={{ color: '#1677ff' }} />
                      <span>API 권한 캐시</span>
                    </Space>
                  )}
                  description={(
                    <Paragraph style={{ marginBottom: 0 }}>
                      시스템은 사용자의 API 호출 권한을 빠르게 검증하기 위해 <Text strong>일시적으로 캐시</Text>합니다.
                      메뉴나 권한이 변경된 후 즉시 반영되지 않는다면 아래 버튼을 눌러 캐시를 수동으로 갱신할 수 있습니다.
                    </Paragraph>
                  )}
                  showIcon
                />
              </Space>
            )
          },
          {
            key: 'sessions',
            label: (
              <Space>
                <LaptopOutlined />
                <span>활성 세션</span>
              </Space>
            ),
            children: (
              <div style={{ marginTop: '-16px' }}>
                <ActiveSessionsManager user={user} />
              </div>
            )
          }
        ]}
      />
    </Modal>
  );
}

export default UserSettingsModal;
